import http from './../index'

//分页查询我的实验室
export const selectMylabListByPage = param => { return http.post("lab-datacenter/customer/selectMylabListByPage", param).then(res => res.data.data) };

//分页查询我的项目映射
export const selectMyMatchListByPage = param => { return http.post("lab-datacenter/customer/selectMyMatchListByPage", param).then(res => res.data.data) };

//新增项目映射
export const addMyMatch = param => { return http.post("lab-datacenter/customer/addMyMatch", param).then(res => res) };


//修改项目映射
export const updateMyMatch = param => { return http.post("lab-datacenter/customer/updateMyMatch", param).then(res => res) };

//删除项目映射
export const delLab = param => { return http.post("lab-datacenter/customer/delMyMatch", param).then(res => res) };

//分页查询我的送检信息(标本管理)
export const selectMySampleListByPage = param => { return http.post("lab-datacenter/customer/selectMySampleListByPage", param).then(res => res.data.data) };

//Excel上传
export const updateExcel = param => { return http.post("lab-datacenter/customer/importSampleInfo", param).then(res => res) };

//手动重传报告通过客户条码
export const updateBarcode = param => { return http.post("lab-datacenter/customer/getReportByCustomerBarcode",param).then(res => res) };

//报告单图片
export const getReportImg = param => { return http.post("lab-datacenter/dataPlatformManagerHospital/selectReportAttachmentList", param).then(res => res) };

//标本结果
export const getReportResult = param => { return http.post("lab-datacenter/dataPlatformManagerHospital/selectReportDetailList", param).then(res => res) };


// WEBPACK FOOTER //
// ./src/http/customer/index.js